/**
 * Summarization store
 */
import { create } from 'zustand';
export const useSummarizationStore = create((set, get) => ({
    summaries: {},
    statuses: {},
    isLoading: {},
    errors: {},
    setSummary: (meetingId, summary) => {
        set((state) => ({
            summaries: {
                ...state.summaries,
                [meetingId]: summary,
            },
        }));
    },
    setStatus: (meetingId, status) => {
        set((state) => ({
            statuses: {
                ...state.statuses,
                [meetingId]: status,
            },
        }));
    },
    setLoading: (meetingId, isLoading) => {
        set((state) => ({
            isLoading: {
                ...state.isLoading,
                [meetingId]: isLoading,
            },
        }));
    },
    setError: (meetingId, error) => {
        set((state) => ({
            errors: {
                ...state.errors,
                [meetingId]: error,
            },
        }));
    },
    getSummary: (meetingId) => {
        return get().summaries[meetingId] || null;
    },
    getStatus: (meetingId) => {
        return get().statuses[meetingId] || null;
    },
    clear: (meetingId) => {
        if (meetingId) {
            set((state) => {
                const newState = { ...state };
                delete newState.summaries[meetingId];
                delete newState.statuses[meetingId];
                delete newState.isLoading[meetingId];
                delete newState.errors[meetingId];
                return newState;
            });
        }
        else {
            set({
                summaries: {},
                statuses: {},
                isLoading: {},
                errors: {},
            });
        }
    },
}));
//# sourceMappingURL=summarization.js.map